import { createContext, type ReactNode, useMemo, useReducer } from "react";
import { createReducer, type Dispatch } from "src/utils/create-reducer";

export type PageViewedState = {
  pageViewTracked: boolean;
};

const initialState: PageViewedState = {
  pageViewTracked: false,
};

export type PageViewedActions =
  | { type: "SET_PAGE_VIEWED"; payload: boolean }
  | { type: "SET_CONSENT_STATUS"; payload: boolean };

export type UsePageViewedContextReturn = {
  pageViewedState: PageViewedState;
  pageViewedDispatch: Dispatch<PageViewedActions>;
};

export const PageViewedContext = createContext<PageViewedState>(initialState);

export const PageViewedDispatch = createContext<
  Dispatch<PageViewedActions> | undefined
>(undefined);

export const pageViewedReducer = createReducer<
  PageViewedState,
  PageViewedActions
>({
  SET_PAGE_VIEWED: (state, payload) => ({ ...state, pageViewTracked: payload }),
  SET_CONSENT_STATUS: (state, payload) => ({ ...state, isConsentSet: payload }),
});

export function PageViewedContextProvider({
  children,
}: {
  children: ReactNode;
}): JSX.Element {
  const [pageViewedState, pageViewedDispatch] = useReducer(pageViewedReducer, {
    ...initialState,
  });
  const pageViewedContextValue = useMemo(
    () => pageViewedState,
    [pageViewedState]
  );

  return (
    <PageViewedContext.Provider value={pageViewedContextValue}>
      <PageViewedDispatch.Provider value={pageViewedDispatch}>
        {children}
      </PageViewedDispatch.Provider>
    </PageViewedContext.Provider>
  );
}
